// project import
import Routes from "routes";
import ThemeCustomization from "themes";
import ScrollTop from "components/ScrollTop";
import React, { useEffect, useLayoutEffect } from "react";
import { AI_getUserData } from "APIs/user";
import socket from "socket/index";
import { AI_getBoards } from "APIs/board";
import NotificationSetup from "notification/NotificationSetup";
import { useInstance } from "../node_modules/easy-redux-http-call/dist/index";

const App = () => {
  const getUserData = useInstance(AI_getUserData);

  useLayoutEffect(() => {
    if (localStorage.getItem("token")) {
      AI_getUserData.call();
    }
  }, []);

  const callBoardApi = (id) => {
    AI_getBoards.refetchAction({
      params: {
        project_id: id,
      },
    });
  };

  // useEffect(() => {
  //   socket.connect();
  //   socket.on("connect", () => {
  //     console.log("A new user connected");
  //   });

  //   // TASK
  //   socket.on("drag_and_drop_task", (data) => callBoardApi(data));
  //   socket.on("update_task", (data) => callBoardApi(data));
  //   socket.on("add_task", (data) => callBoardApi(data));
  //   socket.on("assign_member", (data) => callBoardApi(data));
  //   socket.on("assign_lable", (data) => callBoardApi(data));
  //   socket.on("delete_task", (data) => callBoardApi(data));

  //   // BOARD
  //   socket.on("drag_and_drop_board", (data) => callBoardApi(data));
  //   socket.on("add_board", (data) => callBoardApi(data));

  //   socket.on("connect_error", (err) => {
  //     console.log("Connection error", err);
  //   });
  //   return () => {
  //     socket.disconnect();
  //   };
  // }, []);

  return (
    <ThemeCustomization>
      <ScrollTop>
        <Routes />
      </ScrollTop>
      <NotificationSetup  />
    </ThemeCustomization>
  );
};

export default App;
